export default (path, newWindow = false) => {
  window.open(path, newWindow ? '_blank' : '_self');
};
